import { render, staticRenderFns } from "./PreparingCourseware.vue?vue&type=template&id=482b870a"
import script from "./PreparingCourseware.vue?vue&type=script&lang=js"
export * from "./PreparingCourseware.vue?vue&type=script&lang=js"
import style0 from "./PreparingCourseware.vue?vue&type=style&index=0&id=482b870a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports